import PropTypes from "prop-types"
import React, { createContext, useContext } from "react"

import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

const MarinaContext = createContext({
  marinaSlug: null,
  presentmentCurrency: "USD",
  currencySymbol: "$",
})

export const useMarina = () => {
  const context = useContext(MarinaContext)
  if (!context) {
    throw new Error("useMarina must be used within a MarinaProvider")
  }
  return context
}

export const MarinaProvider = ({ children }) => {
  // Get marina data from global window object (set by Rails)
  const globalMarina =
    typeof window !== "undefined" ? window.currentMarina : null

  const marinaSlug = globalMarina?.marinaSlug || getCurrentMarinaSlug()
  const presentmentCurrency = globalMarina?.presentmentCurrency || "USD"
  const currencySymbol = globalMarina?.currencySymbol || "$"
  const fuelMeasurementUnit = globalMarina?.fuelMeasurementUnit || "gallons"
  const fuelMeasurementUnitSymbol =
    globalMarina?.fuelMeasurementUnitSymbol || "gal"

  const value = {
    marinaSlug,
    presentmentCurrency,
    currencySymbol,
    fuelMeasurementUnit,
    fuelMeasurementUnitSymbol,
  }

  return (
    <MarinaContext.Provider value={value}>{children}</MarinaContext.Provider>
  )
}

MarinaProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
